export enum Parameters {
  BODY_WEIGHT = 'BodyWeight',
  FAT_PERCENTAGE = 'FatPercentage',
  FAT_MASS = 'FatMass',
  MUSCLE_PERCENTAGE = 'MusclePercentage',
  MUSCLE_MASS = 'MuscleMass',
  BODY_MASS_INDEX = 'BodyMassIndex',
  PHYSICAL_FITNESS = 'PhysicalFitness',
  BLOOD_PRESSURE = 'BloodPressure',
  BLOOD_PRESSURE_SYSTOLIC = 'BloodPressureSystolic',
  BLOOD_PRESSURE_DIASTOLIC = 'BloodPressureDiastolic',
  PULSE = 'Pulse',
  CARDIO_FITNESS = 'CardioFitness',
  HEART_STRENGTH = 'HeartStrength',
  CARDIOVASCULAR_RISK = 'CardiovascularRisk',
  STRESS_LEVEL = 'StressLevel',
}
